var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_2148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4793 63.5215H19.7025V71.261H28.4793V63.5215Z",
    fill: "#80AEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7397 57.4277H37.9628V71.2616H46.7397V57.4277Z",
    fill: "#80AEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2975 43.7432H56.5207V71.2613H65.2975V43.7432Z",
    fill: "#80AEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1405 71.2609H69.0165V43.1072C69.0165 41.3873 67.6405 40.0039 65.9297 40.0039H55.8884C54.1777 40.0039 52.8016 41.3873 52.8016 43.1072V71.2609H50.4587V56.7914C50.4587 55.0716 49.0826 53.6882 47.3719 53.6882H37.3306C35.6198 53.6882 34.2438 55.0716 34.2438 56.7914V71.2609H32.1611V62.8858C32.1611 61.1659 30.7851 59.7825 29.0744 59.7825H19.033C17.3223 59.7825 15.9463 61.1659 15.9463 62.8858V71.2609H12.8223C11.781 71.2609 10.9628 72.0834 10.9628 73.1303C10.9628 74.1772 11.781 74.9998 12.8223 74.9998H18.9959H29.0372H37.219H47.2603H55.7397H65.781H71.9545C72.9958 74.9998 73.814 74.1772 73.814 73.1303C73.814 72.0834 72.9958 71.2609 71.9545 71.2609H72.1405ZM19.7025 63.5214H28.4793V71.2609H19.7025V63.5214ZM37.9628 57.427H46.7397V71.2609H37.9628V57.427ZM56.5206 43.7428H65.2975V71.2609H56.5206V43.7428Z",
    fill: "#186CE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9174 45.2387C18.438 45.2387 18.9587 45.0144 19.3306 44.6031L31.157 30.9188L39.3017 40.3034C39.6364 40.6773 40.1198 40.939 40.6033 40.939C41.0868 40.9764 41.6074 40.7895 41.9793 40.4156L65.186 18.2067L65.0744 25.5723C65.0744 26.6191 65.8926 27.4417 66.8967 27.4791C67.9008 27.4791 68.7562 26.6565 68.7562 25.647L68.905 13.907C68.905 13.3835 68.719 12.8975 68.3471 12.561C68.0124 12.1871 67.4917 11.9628 67.0083 12.0001L55.3306 12.1497C54.2893 12.1497 53.4711 13.0096 53.5083 14.0565C53.5083 15.066 54.3636 15.8886 55.3678 15.8886L62.2108 15.7764L40.7521 36.3402L33.5744 28.0399C32.3471 26.6191 29.8554 26.6191 28.5909 28.0399L16.4298 42.0981C15.7603 42.8832 15.8347 44.0423 16.6157 44.7527C16.9504 45.0518 17.3967 45.2013 17.843 45.2013L17.9174 45.2387Z",
    fill: "#186CE8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_2148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartUp);
export default __webpack_public_path__ + "static/media/chart-up.7717ed25b9bf807f28361861fa9429c8.svg";
export { ForwardRef as ReactComponent };